import { Modal as AntModal } from "antd";
import { Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function PaymentDueDate({visible,
  onClose,
  onBilling,
  amount,}) {
  return (
    <AntModal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      maskClosable={false}
      keyboard={false}
      bodyStyle={{
        textAlign: "center",
        padding: "32px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Warning Icon */}
      <WarningAmberIcon sx={{ fontSize: 48, color: "#ff9800", mb: 1 }} />

      {/* Title */}
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Job Posting Disabled
      </Typography>

      {/* Description */}
      <p
        style={{
          fontSize: "1rem",
          lineHeight: 1.6,
          color: "#555",
          marginBottom: 8,
          textAlign: "left",
        }}
      >
        Your payment due date has passed. Please clear the outstanding dues
        of {amount} to continue posting shifts
      </p>

      {/* Action Button */}
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#0057ff",
          textTransform: "none",
          fontWeight: "500",
          px: 4,
          "&:hover": { backgroundColor: "#0046cc" },
          marginTop: "16px",
          width: "100%",
          borderRadius: "8px",
          fontWeight: "bold",
        }}
        onClick={onBilling}
      >
       Pay Now
      </Button>
    </AntModal>
  );
}
